import Vue from 'vue'
import '@/mixins'
import App from './App.vue'
import router from './router'
import '../public/static/font/iconfont.css' // iconfont
import '@/permission' // permission control
import i18n from './lang'
Vue.config.productionTip = false

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element)

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount('#app')
